import React from 'react';
import { Inbox } from 'lucide-react';
import { Button } from '../Button/Button';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  actionLabel,
  onAction,
  className = '',
}) => (
  <div className={`ds-state ${className}`}>
    <div className="ds-state__icon">{icon ?? <Inbox size={24} />}</div>
    <h3 className="ds-state__title">{title}</h3>
    {description ? <p className="ds-state__desc">{description}</p> : null}
    {actionLabel && onAction ? (
      <Button variant="primary" onClick={onAction}>
        {actionLabel}
      </Button>
    ) : null}
  </div>
);

export default EmptyState;
